document.addEventListener("DOMContentLoaded", () => {
  const wrap = document.querySelector("[data-google-reviews]");
  if (!wrap) return;

  const placeId = wrap.dataset.placeId;
  if (!placeId) return;

  const endpoint = `https://api.japantrips.id/reviews?place_id=${encodeURIComponent(placeId)}`;
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${encodeURIComponent(placeId)}`;

  const ratingEl = wrap.querySelector("[data-gr-rating]");
  const countEl = wrap.querySelector("[data-gr-count]");
  const trackEl = wrap.querySelector("[data-gr-track]");
  const dotsEl = wrap.querySelector("[data-gr-dots]");
  const prevBtn = wrap.querySelector("[data-gr-prev]");
  const nextBtn = wrap.querySelector("[data-gr-next]");
  const moreEl = wrap.querySelector("[data-gr-more]");

  const ratingLinkEl = document.querySelector("[data-hp-rating-link]");
  const score10El = document.querySelector("[data-hp-rating-score]");
  const labelEl = document.querySelector("[data-hp-rating-label]");
  const snippetEl = document.querySelector("[data-hp-rating-text]");
  const allCountEl = document.querySelector("[data-hp-rating-count]");

  if (moreEl) moreEl.setAttribute("href", mapsUrl);
  if (ratingLinkEl) {
    ratingLinkEl.setAttribute("href", "#google-reviews");
    ratingLinkEl.addEventListener("click", (e) => {
      e.preventDefault();
      const target = document.getElementById("google-reviews");
      if (!target) return;
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  const esc = (str) =>
    String(str ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const starsHtml = (n) => {
    const r = Math.max(0, Math.min(5, Number(n) || 0));
    return Array.from({ length: 5 })
      .map(
        (_, i) => `<span class="gr-star ${i < r ? "is-on" : ""}">
                      ★
                   </span>`,
      )
      .join("");
  };

  const initials = (name) => {
    const parts = String(name || "G")
      .trim()
      .split(/\s+/)
      .slice(0, 2);
    return parts.map((p) => p[0]?.toUpperCase() || "").join("") || "G";
  };

  const clampText = (t, max = 260) => {
    const s = String(t || "").trim();
    if (s.length <= max) return s;
    return s.slice(0, max - 1) + "…";
  };

  const labelFromScore10 = (s) => {
    const v = Number(s) || 0;
    if (v >= 9.0) return "Exceptional";
    if (v >= 8.0) return "Very good";
    if (v >= 7.0) return "Good";
    if (v >= 6.0) return "Pleasant";
    return "Review score";
  };

  let dotButtons = [];

  const setDots = (pageCount) => {
    if (!dotsEl) return;
    dotsEl.innerHTML = "";
    dotButtons = [];

    for (let i = 0; i < pageCount; i++) {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "gr-dot" + (i === 0 ? " is-active" : "");
      b.setAttribute("aria-label", `Go to page ${i + 1}`);
      b.addEventListener("click", () => {
        if (!trackEl) return;
        const w = trackEl.clientWidth || 1;
        trackEl.scrollTo({ left: i * w, behavior: "smooth" });
      });
      dotsEl.appendChild(b);
      dotButtons.push(b);
    }
  };

  const activateDotByScroll = () => {
    if (!trackEl || !dotButtons.length) return;
    const w = trackEl.clientWidth || 1;
    const page = Math.round(trackEl.scrollLeft / w);
    dotButtons.forEach((b, i) => b.classList.toggle("is-active", i === page));
  };

  const bindNav = () => {
    if (!trackEl) return;

    prevBtn?.addEventListener("click", () => {
      const w = trackEl.clientWidth || 1;
      trackEl.scrollBy({ left: -w, behavior: "smooth" });
    });

    nextBtn?.addEventListener("click", () => {
      const w = trackEl.clientWidth || 1;
      trackEl.scrollBy({ left: w, behavior: "smooth" });
    });

    trackEl.addEventListener("scroll", () => {
      window.requestAnimationFrame(activateDotByScroll);
    });

    window.addEventListener("resize", () => {
      if (!trackEl) return;
      activateDotByScroll();
      const pages = Math.max(
        1,
        Math.ceil(trackEl.scrollWidth / (trackEl.clientWidth || 1)),
      );
      setDots(pages);
      activateDotByScroll();
    });
  };

  fetch(endpoint)
    .then((r) => r.json())
    .then((data) => {
      if (!data || typeof data.rating !== "number") {
        if (trackEl)
          trackEl.innerHTML = `<div class="muted">No reviews available.</div>`;
        if (score10El) score10El.textContent = `—/10`;
        if (labelEl) labelEl.textContent = `—`;
        if (snippetEl) snippetEl.textContent = `No reviews available.`;
        if (allCountEl) allCountEl.textContent = `All reviews`;
        return;
      }

      const rating = Number(data.rating || 0);
      const count = Number(data.userRatingCount || 0);

      if (ratingEl) {
        ratingEl.innerHTML = `${rating.toFixed(1)}/5 
        <span class="gr-google__star" aria-hidden="true">
            ★
        </span>`;
      }
      if (countEl) countEl.textContent = `Based on ${count} reviews`;
      const score5 = Math.round(rating * 10) / 10;
      if (score10El) score10El.textContent = `${score5}/5`;

      const labelFromScore5 = (s) => {
        const v = Number(s) || 0;
        if (v >= 4.5) return "Exceptional";
        if (v >= 4.0) return "Very good";
        if (v >= 3.5) return "Good";
        if (v >= 3.0) return "Pleasant";
        return "Review score";
      };

      if (labelEl) labelEl.textContent = labelFromScore5(score5);

      const allReviews = Array.isArray(data.reviews) ? data.reviews : [];
      const firstWithText = allReviews.find(
        (r) => (r?.text?.text || "").trim().length,
      );
      const snippet = firstWithText?.text?.text || "";
      if (snippetEl)
        snippetEl.textContent = snippet
          ? clampText(snippet, 360)
          : "No review text available.";
      if (allCountEl)
        allCountEl.textContent = `All ${count.toLocaleString("en-US")} reviews`;

      if (!trackEl) return;


      const sorted = allReviews.slice().sort((a, b) => {

        const timeA = a.publishTime ? new Date(a.publishTime).getTime() : 0;
        const timeB = b.publishTime ? new Date(b.publishTime).getTime() : 0;

        return timeB - timeA;
      });

      const take = sorted.slice(0, 12);

      if (!take.length) {
        trackEl.innerHTML = `<div class="muted">No reviews available.</div>`;
        return;
      }

      trackEl.innerHTML = take
        .map((r) => {
          const name = r.authorAttribution?.displayName || "Guest";
          const text = r.text?.text || "";
          const stars = Number(r.rating) || 0;
          const time = r.relativePublishTimeDescription || "";
          const photo = r.authorAttribution?.photoUri || "";

          const avatar = photo
            ? `<img src="${esc(photo)}" alt="${esc(name)}" loading="lazy">`
            : esc(initials(name));

          return `
            <a class="gr-card" href="${mapsUrl}" target="_blank" rel="noopener noreferrer">
            
              <div class="gr-card__metaRow">
                <div class="gr-stars" aria-label="${stars} out of 5 stars">
                    ${starsHtml(stars)}
                </div>
                <div class="gr-author__time"> ${esc(time)}</div>
              </div>

              <div class="gr-author">
                <div class="gr-avatar">${avatar}</div>
                <div>
                  <div class="gr-author__name">${esc(name)}</div>
                </div>
              </div>
            
              <p class="gr-card__text">${esc(clampText(text))}</p>
              
            </a>
          `;
        })
        .join("");

      const pages = Math.max(
        1,
        Math.ceil(trackEl.scrollWidth / (trackEl.clientWidth || 1)),
      );
      setDots(pages);
      bindNav();
      activateDotByScroll();
    })
    .catch(() => {
      if (trackEl)
        trackEl.innerHTML = `<div class="muted">Failed to load reviews.</div>`;
      if (snippetEl) snippetEl.textContent = `Failed to load rating.`;
    });
});
